var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.mvm
    ? _c("div", { staticClass: "info" }, [
        _vm.dvm
          ? _c(
              "div",
              [
                _c(
                  "el-row",
                  [
                    _c("el-col", [
                      _c("h2", [
                        _vm._v("機台編號：" + _vm._s(_vm.mvm.AssetNo)),
                      ]),
                      _c(
                        "h3",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.mvm.client,
                              expression: "mvm.client",
                            },
                          ],
                        },
                        [
                          _vm._v(
                            "客戶名稱： " +
                              _vm._s(
                                _vm.mvm.client && _vm.mvm.client.customer_code
                              ) +
                              " " +
                              _vm._s(_vm.mvm.client && _vm.mvm.client.name)
                          ),
                        ]
                      ),
                      _c(
                        "h3",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.mvm.op_locate,
                              expression: "mvm.op_locate",
                            },
                          ],
                        },
                        [
                          _vm._v(
                            "機台位置：" +
                              _vm._s(
                                _vm.mvm.op_locate &&
                                  _vm.mvm.op_locate.location_code
                              ) +
                              " " +
                              _vm._s(
                                _vm.mvm.op_locate &&
                                  _vm.mvm.op_locate.location_name
                              )
                          ),
                        ]
                      ),
                      _c("h3", [
                        _vm._v(
                          "發票是否啟用：" +
                            _vm._s(
                              _vm.mvm.invoice_settings.Invoice
                                ? "啟用"
                                : "不啟用"
                            )
                        ),
                      ]),
                      _c("h3", [
                        _vm._v(
                          "發票啟用起始時間：" +
                            _vm._s(_vm.mvm.invoice_settings.EnableSince)
                        ),
                      ]),
                      _c("h3", [
                        _vm._v(
                          "是否列印發票：" +
                            _vm._s(
                              _vm._f("printInvoiceFilter")(
                                _vm.dvm.setting.printInvoice
                              )
                            )
                        ),
                      ]),
                      _c("h3", [
                        _vm._v(
                          "是否列印明細：" +
                            _vm._s(
                              _vm._f("printDetailFilter")(
                                _vm.dvm.setting.printReceipt
                              )
                            )
                        ),
                      ]),
                    ]),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { staticClass: "gates" },
                      [
                        _c(
                          "el-row",
                          _vm._l(_vm.dvm.gates, function (gate, index) {
                            return _c(
                              "el-col",
                              { key: index, attrs: { lg: 6, sm: 12, xs: 24 } },
                              [
                                _c(
                                  "el-card",
                                  {
                                    staticClass: "gate",
                                    class: _vm._f("statusFilter")(gate),
                                    attrs: { shadow: "hover" },
                                  },
                                  [
                                    _c("h2", [
                                      _vm._v("貨道 " + _vm._s(gate.GateNo)),
                                    ]),
                                    _c(
                                      "div",
                                      { staticClass: "d-flex flex-row" },
                                      [
                                        gate.Product.ProductNa
                                          ? _c(
                                              "div",
                                              { staticClass: "m-0 pl-0" },
                                              [
                                                _c(
                                                  "h2",
                                                  {
                                                    staticClass:
                                                      "bg-light p-1 text-dark rounded m-0 mb-1",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          gate.Product.ProductNa
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "el-table",
                                                  {
                                                    staticStyle: {
                                                      "font-size": "1.2rem",
                                                    },
                                                    attrs: {
                                                      data: [gate],
                                                      size: "mini",
                                                      "cell-style": {
                                                        fontSize: "1.8rem",
                                                        textAlign: "center",
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("el-table-column", {
                                                      attrs: {
                                                        width: "60",
                                                        prop: "Product.UnitPrice",
                                                        label: "售價",
                                                      },
                                                    }),
                                                    _c("el-table-column", {
                                                      attrs: {
                                                        width: "60",
                                                        prop: "Stock",
                                                        label: "庫存",
                                                      },
                                                    }),
                                                    _c("el-table-column", {
                                                      attrs: {
                                                        width: "60",
                                                        prop: "Sales",
                                                        label: "銷售",
                                                      },
                                                    }),
                                                    _c("el-table-column", {
                                                      attrs: {
                                                        width: "60",
                                                        prop: "Short",
                                                        label: "缺補",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }